import { ENV } from './environment';

export function devPrint(...rest: any) {
  if (ENV.isDev) console.log(...rest);
}

export function removeSpaces(str: string = '') {
  return str.toLowerCase().replace(/\s/g, '');
}
